const env = {
  url: 'http://localhost:8080/',
  urlDev: 'http://localhost:8080/',
  urlCert: 'https://api.testito.contifast.com/',
  urlProd: 'https://api.contifast.com/',
};
const envSite = {
  url: 'http://localhost:5173/',
  urlDev: 'http://64.23.164.232/',
  urlCert: 'https://testito.contifast.com/',
  urlProd: 'https://contifast.com/',
};

const keyValueCrypto = '7f3d8e2a9b1c5f4e6d8a2c9b7e3f1a5d8e2a9b1c5f4e6d8a2c9b7e3f1a5d8e2a';
const ivKeyCrypto = '9b1c5f4e6d8a2c9b7e3f1a5d8e2a9b1c';
export default { env, envSite, keyValueCrypto, ivKeyCrypto };
